<template>
<div class="container card" :class="navbarFixed ? 'mt-8': 'mt-4'">
    <div class="card-header">
        <h2
            v-if="plan"
            class="text-muted text-center"
        >{{$t('login.subscribe_message')}}{{plan.name}}</h2>
        <span class="text-muted">
            {{$t('login.has_account')}}
            <span
                @click="showLoginDialog"
                role="button"
                class="text-muted text-center font-weight-bold cursor-pointer"
            >{{$t('login.access_here')}}</span>
        </span>
    </div>
    <form role="form" class="mt-3" autocomplete="off">
        <base-input
            v-model="model.name"
            v-validate="'required'"
            :name="$t('login.name')"
            class="mb-3 px-3"
            :placeholder="$t('login.name')"
            :disabled="this.hasntPasswordField"
            prepend-icon="ni ni-circle-08"
            :error="errors.first($t('login.name'))"
        />
        <base-input
            v-model="model.email"
            v-validate="'email'"
            :name="$t('login.email')"
            class="mb-3 px-3"
            :placeholder="$t('login.email')"
            :disabled="this.hasntPasswordField"
            prepend-icon="ni ni-email-83"
            :error="errors.first($t('login.email'))"
        />
        <document-input
            class="px-3"
            ref="doc_form"
            v-model="model"
            :required="!!form.document_required"
        />
        <form-builder ref="builder_form" v-model="formBuilder" />
        <address-form
            class="px-3"
            v-if="form.enable_addresses"
            ref="address_form"
            v-model="address"
        />
        <div class="px-3" v-if="!hasntPasswordField">
            <base-input
                v-model="model.password"
                v-validate="{required: true, min: 6}"
                :name="$t('login.password.title')"
                type="password"
                :placeholder="$t('login.password.title')"
                prepend-icon="ni ni-lock-circle-open"
                :error="errors.first($t('login.password.title'))"
            />
            <base-input
                v-model="model.password_confirmation"
                v-validate="{ is: model.password, required: true, min: 6 }"
                :name="$t('login.password.confirm')"
                type="password"
                :placeholder="$t('login.password.confirm')"
                prepend-icon="ni ni-lock-circle-open"
                :error="errors.first($t('login.password.confirm'))"
                @keypress.enter="submit"
            />
        </div>
        <div class="text-center">
            <div v-if="template.status">
                <template v-if="settings.terms_checkbox">
                    <base-checkbox v-model="checkbox_status">
                        <span v-html="template.title"/>
                    </base-checkbox>
                </template>
                <template v-else>
                    <span v-html="template.title"/>
                </template>
            </div>
            <base-button
                @click.stop="submit"
                :loading="loading"
                :disabled="handleRegisterDisable"
                type="success"
                :style="$bgColor(buttonColor)"
                class="my-4"
            >{{ $t('login.register') }}</base-button>
        </div>
    </form>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

import BaseButton from '../../argon/components/BaseButton';
import BaseInput from '../../argon/components/Inputs/BaseInput';
import BaseCheckbox from '../../argon/components/Inputs/BaseCheckbox';

import FormBuilder from '../../components/FormBuilderComponents/FormBuilder';
import DocumentInput from '../Common/DocumentInput';
import AddressForm from '../FormBuilderComponents/ContentComponents/AddressForm';


export default {
    name: 'RegisterFormBuilder',
    components: {
        FormBuilder,
        BaseInput,
        BaseButton,
        DocumentInput,
        AddressForm,
        BaseCheckbox,
    },

    data() {
        return {
            model: {
                name: '',
                email: '',
                document: '',
                document_type: '',
                password: '',
                password_confirmation: '',
                language: localStorage.getItem('lang'),
            },
            checkbox_status: false,
            loading: false,
            formBuilder: this.form,
            address: {
                location: {
                    zip: '',
                    address: '',
                    number: '',
                    neighborhood: '',
                    country: '',
                    state: '',
                    city: '',
                    info: '',
                    code: 'BR',
                },
            },
        };
    },

    props: {
        form: {
            type: Object,
            required: true,
        },
        hasntPasswordField: {
            type: Object,
            required: false,
        },
        documents: {
            type: Array,
            required: true,
        },
        settings: {
            type: Object,
            required: true,
        },
        template: {
            type: Object,
            required: true,
        },
        loginSocial: {
            type: Array,
            required: true,
        },
    },

    methods: {
        showLoginDialog() {
            this.$store.commit('DIALOG_SHOW', {
                redirect: '/app/dashboard',
                social: this.loginSocial,
            });
        },
        generatePassword() {
            const arr = new Uint32Array(3);
            const genPassword = window.crypto.getRandomValues(arr);
            const toStr = genPassword.toString();
            const r = toStr.replace(/,/g, '');
            return r;
        },
        async submit() {
            // Valida o form dos componentes filhos
            const forms = Object.values(this.$refs)
                .map(form => form.$validator.validate());
            const formStatus = await Promise.all(forms);
            const childrenValid = formStatus.every(status => status);

            // Validação de domínio de e-mail, quando se tem categorias
            let domainValid = true;
            if (this.formBuilder.enable_students_categories) {
                const categoryField = this.formBuilder.fields.find(field => field.name === 'Categorias_dos_alunos');
                if (categoryField.data.value) {
                    const optionId = categoryField.data.value;
                    const optionSelected = categoryField.options.find(op => op.id == optionId);
                    const domains = optionSelected.valid_domains;
                    if (domains.length && !this.validateEmail(optionSelected, domains)) {
                        domainValid = false;
                        return this.$notify({
                            type: 'danger',
                            message: this.$t('login.domain_invalid'),
                        });
                    }
                }
            }
            // Verifica se o tipo do documento foi selecionado
            if (
                !!this.form.document_required
                && !this.model.document_type
                && this.documents?.length
            ) {
                return this.$notify({
                    type: 'danger',
                    message: this.$t('login.document_type_required'),
                });
            }

            return this.$validator.validate().then(async (valid) => {
                if (valid && childrenValid && domainValid) {
                    this.loading = true;
                    window.axios
                        .post('/register', {
                            ...this.model,
                            form: { ...this.formBuilder },
                            address: this.address,
                            terms_accept: this.checkbox_status ? 1 : 0,
                        })
                        .then((res) => {
                            this.$notify({
                                type: 'success',
                                message: res.data.message,
                            });
                            localStorage.setItem(
                                'nochalks_token',
                                res.data.token,
                            );
                            localStorage.removeItem('social');
                            this.loginRegisteredUser();
                        })
                        .catch((err) => {
                            this.displayErrorMessages(err.response.data.errors);
                            this.loading = false;
                        });
                }
            });
        },
        subscribe() {
            return window.axios
                .post(`api/cart/add/${this.plan.id}`)
                .then(res => res);
        },
        displayErrorMessages(errors) {
            if (Array.isArray(errors)) {
                return errors.forEach((error) => {
                    this.$notify({
                        type: 'danger',
                        message: error,
                    });
                });
            }

            return this.$notify({
                type: 'danger',
                message: errors,
            });
        },
        loginRegisteredUser() {
            window.axios
                .post('/authenticate', this.model)
                .then((res) => {
                    this.$notify({
                        type: 'success',
                        message: res.data.message,
                    });
                    localStorage.setItem('nochalks_token', res.data.token);

                    if (this.plan) {
                        this.subscribe().then(() => {
                            location.href = '/app/dashboard';
                        });
                    } else {
                        localStorage.removeItem('redirect');
                        this.$redirect(
                            res.data.redirectTo
                                ? res.data.redirectTo
                                : '/app/dashboard',
                            1500,
                        );
                    }
                })
                .catch(() => {
                    this.$notify({
                        type: 'danger',
                        message: this.$t('login.messages.error'),
                    });
                    this.loading = false;
                });
        },

        validateEmail(optionSelected, domains) {
            const email = this.model.email;
            const emailDomain = email.slice(email.indexOf('@') + 1);
            if (!optionSelected.filter_valid_domains) return true;
            return domains.some(domain => domain === emailDomain);
        },
    },
    computed: {
        ...mapGetters({
            color: 'COLOR',
            isValid: 'FORM_VALID',
            social: 'LOADED_SOCIAL_LOGIN',
            navbarFixed: 'NAVBAR_FIXED',
            plan: 'SUBSCRIBE_PLAN',
        }),
        buttonColor() {
            return (this.color && (this.color.button || this.color.primary)) || '#5e72e4';
        },
        handleRegisterDisable() {
            if (this.template.status
                && this.settings.terms_checkbox
                && !this.checkbox_status
            ) {
                return true;
            }
            return false;
        },
    },
    mounted() {
        if (this.hasntPasswordField) {
            const data = this.hasntPasswordField;
            this.model.name = data.name;
            this.model.email = data.email;

            const pass = this.generatePassword();

            this.model.password = pass;
            this.model.password_confirmation = pass;
        }
        if (localStorage.getItem('plan-id')) {
            this.$store.commit('SET_SUBSCRIBE_PLAN', {
                id: localStorage.getItem('plan-id'),
                name: localStorage.getItem('plan'),
            });
            localStorage.removeItem('plan');
            localStorage.removeItem('plan-id');
        }
    },
};
</script>
